import { h } from 'preact'
export const StarHalf = () => {
    return (
      <svg class="icon icon-half-star" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <g id="WIP" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Artboard" transform="translate(-761.000000, -263.000000)">
                  <g id="star-half" transform="translate(761.000000, 263.000000)">
                      <polygon id="Star" fill="#BFBFBF" points="7.5 10.4727772 3.09161061 13.5676275 4.67272084 8.41863868 0.367076128 5.18237254 5.75264539 5.0949727 7.5 0 9.24735461 5.0949727 14.6329239 5.18237254 10.3272792 8.41863868 11.9083894 13.5676275"></polygon>
                      <polygon id="Star" fill="#000000" points="7.5 10.4727772 3.09161061 13.5676275 4.67272084 8.41863868 0.367076128 5.18237254 5.75264539 5.0949727 7.5 7.01660952e-14"></polygon>
                  </g>
              </g>
          </g>
      </svg>
    )
}
